import { Injectable, inject } from '@angular/core'
import { LayerAPIService } from '@modules/bv-api'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { fetchAllLayers, fetchAllLayersError, fetchAllLayersSuccess } from './actions'
import { TranslationService } from '@ziptility/services'

@Injectable()
export class LayersEffects {
  readonly actions$ = inject(Actions)
  readonly layerAPIService = inject(LayerAPIService)
  readonly translationService = inject(TranslationService)

  AllLayersRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAllLayers),
      switchMap(() =>
        this.layerAPIService.list().pipe(
          map((layers) =>
            fetchAllLayersSuccess({
              layers: layers.map((l) => ({ ...l, singularTitle: this.translationService.singularize(l.title) })),
            }),
          ),
          catchError((error) => of(fetchAllLayersError({ error }))),
        ),
      ),
    ),
  )
}
